module.exports = __webpack_public_path__ + "img/menu-bg.1521ae0d.png";